import React, {Component} from 'react';
        import {Link, Redirect} from "react-router-dom";
        import Pagination from "react-js-pagination";
        import $ from 'jquery';
        import Header from './../../Header';
        import HeaderMob from './../../HeaderMob';
        import moment from 'moment';
        import customer_analytics1 from '../../assets/images/customer_analytics1.png';
        import customer_analytics2 from '../../assets/images/customer_analytics2.png';
        import customer_analytics3 from '../../assets/images/customer_analytics3.png';
        import customer_analytics4 from '../../assets/images/customer_analytics4.png';
        import CryptoJS from 'crypto-js';
        import config from 'react-global-configuration';
        class EnterpriseDetails extends Component {
        constructor() {
        super();
                var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
                var localdata = has_local_data?this.decrypt(localStorage.getItem('encdata'), 0):'';
                this.state = {
                data: [],
                        applications: [],
                        login_details: [],
                        upload_details: [],
                        packageData: [],
                        package_name:'',
                        apiKey:'',
                        apiKeyStatus:'',
                        count: '',
                        key: 1,
                        packageData: '',
                        bandwidth_log:'',
                        storage:'',
                        currency:[],
                        apiUrl:this.decryptconfigdata('apiUrl'),
                        studioUrl:this.decryptconfigdata('studioUrl'),
                        userAuthKey:has_local_data?localdata.user_key:'',
                        userId:has_local_data?localdata.user_id:''
                };
                this.getCustomerDetails = this.getCustomerDetails.bind(this);
                this.handlePageChange = this.handlePageChange.bind(this);
                this.formdateChange = this.formdateChange.bind(this);
                this.todateChange = this.todateChange.bind(this);
                this.keywordChange = this.keywordChange.bind(this);
                this.onChange = this.onChange.bind(this);
        }
        decryptconfigdata(configkey){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return plaintext;
        }

        decrypt(findresponse, flg){
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
                var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
                var res = flg ? findresponse.encdata : findresponse;
                var bytes = CryptoJS.AES.decrypt(res, key, {
                iv
                });
                var plaintext = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(plaintext);
        }
        rawjsonparse(findresponse, flg) {
        return findresponse;
        }
        goToCustomerStore(email, password, studio_id){
        if (window.confirm('Are you sure to login this store')) {
        var win = window.open(this.state.studioUrl + "/login/storeLogin/email/" + email + "/password/" + password + "/studio_id/" + studio_id, '_blank');
                win.focus()
        }
        }
        handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
                this.getCustomers(pageNumber);
        }
        formdateChange(event) {
        this.setState({from_date: event.target.value}, function () {
        this.getCustomers();
        });
        }
        todateChange(event) {
        this.setState({to_date: event.target.value}, function () {
        this.getCustomers();
        });
        }
        keywordChange(event) {
        var obj = this;
                this.setState({
                search: event.target.value,
                });
                //Delaying the function execute
                if (this.timer) {
        window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
        //Execute the function code here...
        obj.getCustomers();
        }, 500);
        }
        onChange(propertyName, event){
        this.setState({package_name: event.target.value}, function () {
        //this.getCustomers();
        });
        }
        toggle1() {
        $('#sdk_change').hide();
                $('#sdk_change_save').show();
                $('#sdk_name').hide();
                $('#sdk_span_txt').show();
        }
        toggle2() {

        var sdk_name = $('#sdk_name_txt').val();
                if (sdk_name == '')
        {
        alert("Sdk name can not be empty");
                return false;
        }
        else {
        if (window.confirm('Are you sure to update the sdk name ?')) {
        var studios_id = $('#studios_id').val();
                $.post(this.state.apiUrl + '/adminRest/updatesdk', {'sdk_name':sdk_name, 'studio_id':studios_id, 'userAuthKey':this.state.userAuthKey}, function(res){
                $('#sdk_change').show();
                        $('#sdk_change_save').hide();
                        $('#sdk_name').show();
                        $('#sdk_span_txt').hide();
                });
                this.getCustomerDetails();
        }

        }
        }

        disabletoken() {
        if (window.confirm('Are you sure, you want to disable the API Key for this studio?')) {
        var studios_id = $('#studios_id').val();
                $.post(this.state.apiUrl + '/adminRest/disableApiKey', {'studio_id':studios_id, 'userAuthKey':this.state.userAuthKey}, function(res){
                });
        }
        this.getCustomerDetails();
        }

        generatetoken() {
        if (window.confirm('Are you sure, you want to create the API Key for this studio?')) {
        var studios_id = $('#studios_id').val();
                $.post(this.state.apiUrl + '/adminRest/GenerateApiKey', {'studio_id':studios_id, 'userAuthKey':this.state.userAuthKey}, function(res){
                });
        }
        this.getCustomerDetails();
        }

        getCustomerDetails(){
        fetch(this.state.apiUrl + '/adminRest/ViewDetail/studioId/' + this.props.match.params.studioId + '/type/' + this.props.match.params.type + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
        method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse) =>
                {
                findresponse = this.rawjsonparse(findresponse, 1);
                        this.setState({
                        data: findresponse.data,
                                applications : findresponse.applications,
                                s3locations: findresponse.s3locations,
                                apiKey: findresponse.apiKey,
                                apiKeyStatus: findresponse.apiKeyStatus,
                                bandwidth_log: findresponse.bandwidth_log,
                                storage:findresponse.storage,
                                currency:findresponse.currency,
                                keyaccount:findresponse.keyaccount,
                                store_permission: findresponse.store_permission,
                                package_name: findresponse.package_name
                        })
                })
        }

        showLoginDetails(){
        fetch(this.state.apiUrl + '/adminRest/showLoginDetails/studioId/' + this.props.match.params.studioId + '/type/' + this.props.match.params.type + '/userAuthKey/' + this.state.userAuthKey, {
        method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse) =>
                {
                findresponse = this.rawjsonparse(findresponse, 1);
                        this.setState({
                        login_details: findresponse.login_details,
                        })
                })
        }

        showUploadDetails(){
        fetch(this.state.apiUrl + '/adminRest/showUploadDetails/studioId/' + this.props.match.params.studioId + '/type/' + this.props.match.params.type + '/userAuthKey/' + this.state.userAuthKey, {
        method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse) =>
                {
                findresponse = this.rawjsonparse(findresponse, 1);
                        this.setState({
                        upload_details: findresponse.upload_details,
                                count: findresponse.count,
                        })
                })
        }

        getuploaddetails(){
        return (
<div class="list_check">
    <div class="tickets hidden-sm">
        <ul class="tickets_head">
            <li class="intra_col_22">File Name</li>
            <li class="intra_col_13">Upload Start time</li>
            <li class="intra_col_13">Upload End Time</li>
            <li class="intra_col_13">Upload Cancel Time</li>
            <li class="intra_col_13">Encode Start Time</li>
            <li class="intra_col_13">Encode End Time</li>
            <li class="intra_col_13">Encode Fail Time</li>
        </ul>
        {this.state.upload_details.map((upload_details, key) =>
        <ul class="tickets_number">       
            <li class="intra_col_22">{upload_details.film_name}</li>
            <li class="intra_col_13">{upload_details.upload_start_time}</li>
            <li class="intra_col_13">{upload_details.upload_end_time}</li>
            <li class="intra_col_13">{upload_details.upload_cancel_time}</li>
            <li class="intra_col_13">{upload_details.encoding_start_time}</li>
            <li class="intra_col_13">{upload_details.encoding_end_time}</li>
            <li class="intra_col_13">{upload_details.encode_fail_time}</li>        
        </ul>
                        )}  
    </div>
</div>

                )

        }

        getcardDetails(is_subscribed, status, deleted, is_default){
        if (is_subscribed == 1 && status == 1 && deleted == 0 && is_default == 0) {
        // let fullDate = new Date()
        return(
<div class="card">
    <h5>Card Details</h5>
    <div class="card-details">
        {this.state.data.map((data, key) =>
        <div class="card-info">                           
            <div class="pull-left">
                <h6>{data.card_last_fourdigit}</h6>
                <h5>{data.card_holder_name}</h5>
            </div>
            <div class="pull-right">
                <h5>Valid Thu</h5>
                <h6>{data.cancelled_date ? data.cancelled_date : 'N/A'}</h6>
            </div>
        </div>
                        )}
    </div>
</div>

                )
        } else {
        return ''
        }
        }
        getRevenue(){
        if (this.state.currency.length > 0){
        return(
<select class="form-control customer_form-control">
    {this.state.currency.map((currency, key) =>
    <option value="">{currency.symbol} {currency.amount}</option>
                        )}
</select>
                )
        }
        }
        getPackageDetails(){
        if (this.state.applications.length > 0){
        return(
<div class="card-info">
    <h5 class="card">Package Selected</h5>
     <div class="pull-left">
        {this.state.applications.map((data, key) =>
        <div  class="add_card">{data.package_selected == 1?<div class="price">{'$ ' + data.price}</div>:<div class="">{'$ ' + data.price}</div>}<div class="wb">{data.name}</div></div>
                        )}
    </div>

</div>
                                )
                        }
                }
                getpackagesummary(is_subscribed, status, package_details){
                if (is_subscribed == 1 && status == 1 && package_details != '') {
                return(
<div class="card">
    <h5>Package Summary</h5>
    {this.state.data.map((data, key) =>
    <ul class="tickets_number summary">
        <li class="intra_col_33"><div class="summary_title">Package Name</div><div class="summary_des">{data.package.name}</div></li>
        <li class="intra_col_33"><div class="summary_title">Package Type</div><div class="summary_des">{data.sel_plan}</div></li>
        <li class="intra_col_33"><div class="summary_title">Package Price</div><div class="summary_des">{data.package?(data.is_old != '0' && data.is_old != 0 && data.package.is_old_base_price != '0' && data.package.is_old_base_price != 0 ? '$ '+data.base_price : '$ '+data.package.base_price):'--'}</div></li>
    </ul>
                                )}
    {this.state.data.map((data, key) =>
    <ul class="tickets_number summary">

        {console.log(new Date())}
        <li class="intra_col_33"><div class="summary_title">Last transaction Date</div><div class="summary_des">{data.created_date && data.created_date != '' && data.created_date != '00-00-00 00:00:00' ? new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: '2-digit'}).format(new Date(data.created_date)) : 'N/A'}</div></li>
        <li class="intra_col_33"><div class="summary_title">Transaction Amount</div><div class="summary_des">{data.paid_amount ? '$ ' + data.paid_amount : 'N/A'}</div></li>
        <li class="intra_col_33"><div class="summary_title">Next Subscription Date</div><div class="summary_des">{data.start_date && data.start_date != '' && data.start_date != '00-00-00 00:00:00' ? new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: '2-digit'}).format(new Date(data.start_date)) : data.end_date && data.end_date != '' && data.end_date != '00-00-00 00:00:00' ? new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: '2-digit'}).format(new Date(data.end_date)) : 'N/A'}</div></li>
    </ul>
                        )}

    {this.getPackageDetails()}

</div>
                        )
                } else {
                return ''
                }
                }

                componentDidMount()
                {
                this.getCustomerDetails();
                        this.showLoginDetails();
                        this.showUploadDetails();
                        document.title = "Intranet | Customer Details";
                        if (!localStorage.getItem('userLogin')){
                this.setState({redirect:true});
                }
                }
                render() {
                if (this.state.redirect) {
                return (
<Redirect to={'/login'} />
                        )
                }
                return (
<div >
    <Header brecum_name="Customer" brecum_page="Enterprise Details"/>
    <div className="right_col">
        <div class="title mob hidden-md">
            <HeaderMob page_name="Customer Details"/>
        </div>
        <section class="customer">
            <div id="exTab1" class="container">	
                <ul  class="nav nav-pills">
                    <li class="active">
                        <a  href="#CustomersInfo" data-toggle="tab">Store&apos;s Info</a>
                    </li>
                    <li><a href="#Login" data-toggle="tab">Login</a>
                    </li>
                    <li><a href="#Upload" data-toggle="tab">Upload</a>
                    </li>
                </ul>

                <div class="tab-content customer-tab clearfix">
                    <div class="tab-pane active" id="CustomersInfo">
                        <div class="customer_product">
                            <div class="customer_product_head">
                                <div class="row">
                                    {this.state.data.map((data, key) =>
                                    <div class="customer_product_info col-md-3 col-xs-12 text-center border-btn">
                                        <h2  style={{color: "#0cb9f2"}}>{data.name}</h2>
                                        <h6>{data.first_name} {data.last_name}</h6>
                                        <div class="customer_location">
                                            <h5>{data.domain}</h5>
                                            <h5>{data.email}</h5>
                                            <h5>{data.signup_location}</h5>
                                        </div>
                                        <h6>{data.total_login}</h6>
                                        <h5>Total Login</h5>
                                    </div>
                                        )}
                                    {this.state.data.map((data, key) =>
                                    <div class="customer_product_info col-md-5 col-xs-12 border-btn">
                                        <div class="row">
                                            <div class="customer_product_addressI col-md-6 col-sm-6 col-xs-6 word-break">
                                                <h6>Joined On</h6>
                                                <h4>{new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: '2-digit'}).format(new Date(data.created_at))}</h4>
                                                <div class="customer_location">
                                                    <h6>S3 Location</h6>
                                                    <h4 id="region_name">{data.region_name}</h4>
                                                    <div class="filter customer_filter">
                                                        <select class="form-control customer_form-control">
                                                            <option value="All_levels">Singapore</option>
                                                            <option value="saab">Saab</option>
                                                            <option value="mercedes">Mercedes</option>
                                                            <option value="audi">Audi</option>
                                                        </select>
                                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                                <div class="api_key">
                                                    <h5>API Key</h5>
                                                    <span>{this.state.apiKey ? this.state.apiKey : 'N/A'} {this.state.apiKey ? (this.state.apiKeyStatus == 1 ? <a id="disable_token_button" href="javascript:void(0);" class="btn btn-trans" onClick={() => this.disabletoken()} >Disable Token</a> : <span class="disabled">Disabled</span>) : <a  href = "javascript:void(0);" class="btn btn-trans" onClick={() => this.generatetoken()}>Generate Token</a>}</span>
                                                    {/* <span>{this.state.apiKey ? (this.state.apiKeyStatus == 1 ? <a  href = {this.state.apiUrl + '/adminRest/disableApiKey/studio_id/' +data.id} >Disable Token</a> : <span class="disabled">Disabled</span>) : <a  href = {this.state.apiUrl + '/adminRest/GenerateApiKey/studio_id/' +data.id}>Generate Token</a>}</span> */}
                                                </div>
                                            </div>

                                            <div class="customer_product_addressII col-md-6 col-sm-6 col-xs-6 word-break">
                                                <h6>Billing Inception Date</h6>
                                                <h4>{new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short', day: '2-digit'}).format(new Date(data.subscription_start))}</h4>
                                                <div class="customer_location">
                                                    <div class="api_key">
                                                        <h6>SDK Name</h6>
                                                        <h6 ><span id="sdk_name" style={{width: "100%"}}>{this.state.package_name ? this.state.package_name : 'N/A'} </span>
                                                            <span id="sdk_change"><a href="javascript:void(0);" class="btn btn-trans" onClick={this.toggle1.bind(this)}>Change</a></span>
                                                            <span id="sdk_span_txt" style={{display: "none"}}>   
                                                                <input style={{width: "100%"}} type="text" id="sdk_name_txt" name="sdk_name" value={this.state.package_name} onChange={this.onChange.bind(this, 'package_name')}/> 
                                                                <input type="hidden" id="studios_id" name="studios_id" value={data.id} />
                                                            </span>
                                                            <span id="sdk_change_save" style={{display: "none"}}><a a href="javascript:void(0);" class="btn btn-trans" onClick={this.toggle2.bind(this)}>Save</a></span>
                                                        </h6></div></div>
                                            </div>
                                        </div>
                                    </div>
                                                )}
                                    {this.state.data.map((data, key) =>
                                    <div class="customer_product_info col-md-4 col-xs-12">
                                        {this.getcardDetails(data.is_subscribed, data.status, data.is_deleted, data.is_default)}
                                    </div>
                                                )} 
                                </div>
                            </div>

                            <div class="package_summary"> 
                                <div class="row">
                                    {this.state.data.map((data, key) =>
                                    <div class="customer_product_info summary col-md-8 col-sm-6 border-btn">
                                        {this.getpackagesummary(data.is_subscribed, data.status, data.package)}                                            
                                    </div>

                                                )}

                                    <div class="Analytics col-md-4 col-sm-6 col-xs-12">
                                        <div class="card"><h5>Analytics<i class="fa fa-calendar-alt pull-right"></i></h5></div> 
                                        <div class="row">
                                            {this.state.data.map((data, key) =>
                                            <div class="analytics col-md-6 col-xs-6">
                                                <div class="main">
                                                    <div class="pro_image">
                                                        <img src={customer_analytics1}/>
                                                    </div>

                                                    {this.getRevenue()}
                                                    <span>Revenue</span>
                                                </div>
                                            </div>
                                                )}
                                            {this.state.data.map((data, key) =>
                                            <div class="analytics col-md-6 col-xs-6">
                                                <div class="main">
                                                    <div class="pro_image">
                                                        <img src={customer_analytics2}/>
                                                    </div>
                                                    <h6>{this.state.storage}</h6>
                                                    <span>Storage</span>
                                                </div>
                                            </div>
                                                )}

                                            <div class="analytics col-md-6 col-xs-6">
                                                <div class="main">
                                                    <div class="pro_image">
                                                        <img src={customer_analytics4}/>

                                                    </div>
                                                    <h6>{this.state.bandwidth_log ? this.state.bandwidth_log : '0 B'}</h6>
                                                    <span>Bandwidth</span>
                                                </div>
                                            </div>

                                            {this.state.data.map((data, key) =>
                                            <div class="analytics col-md-6 col-xs-6">
                                                <div class="main">
                                                    <div class="pro_image">
                                                        <img src={customer_analytics3}/>
                                                    </div>
                                                    <h6>{data.total_users}</h6>
                                                    <span>Users</span>
                                                </div>
                                            </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                    <div class="tab-pane" id="Login">
                        {this.state.login_details.map((details, key) =>
                        <div class="row">
                            <div class="box-body">
                                <div class="col-md-6">
                                    <span>{details.logout_at != '0000-00-00 00:00:00' && details.logout_at != ' ' ? details.email : ''}</span>
                                    <span>{details.login_at != '0000-00-00 00:00:00' && details.login_at != ' ' ? details.email : ''}</span>
                                </div>
                                <div class="col-md-6">
                                    <span>{details.logout_at != '0000-00-00 00:00:00' && details.logout_at != ' ' ? details.logout_at : ''}</span>
                                    <span style={{float: "right"}}>{details.login_at != '0000-00-00 00:00:00' && details.login_at != ' ' ? details.login_at : ''}</span>
                                </div>
                            </div>
                        </div>
                                                        )}          
                    </div>
                    <div class="tab-pane" id="Upload">
                        {this.state.count > 0? this.getuploaddetails() : <span style={{color: "black"}}>No data found.</span>}                               
                    </div>
                </div>                                      
            </div>
        </section>
    </div>
</div>
                                                        );
                                                }
                                                }

                                        export default EnterpriseDetails;


// WEBPACK FOOTER //
// ./src/components/customer/EnterpriseDetails.js